'use client'
import { LinkExternal } from '@/types/common/LinkExternal'
import s from './Quote.module.scss'
import { useContext, useEffect, useState } from 'react'
import Link from 'next/link'
import React from 'react'
import LazyImage from '@/components/common/LazyImage'

interface QuoteProps {
    data: DataProps
}

interface DataProps {
    _type: string;
    _ref: string;
    quote: string;
    author: string | null;
}

export default function QuoteComponent({
data
}: QuoteProps) {

    return (
        <div className={s.quote}>
            <h3 dangerouslySetInnerHTML={{__html: data.quote}}></h3>
            {data.author && <p>{data.author}</p>}
        </div>
    )
}
